import styled, { css } from 'styled-components';

import { Button } from '@speeki/global-ui-components';
import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const ConversationTitle = styled(Typography.TextH1_36_52)(
    ({ theme: { fontSize, fontWeight } }) => css`
        margin-bottom: 32px;
        text-align: center;

        @media (max-width: ${breakpoints.md}px) {
            font-size: ${fontSize[24]}px;
            font-weight: ${fontWeight.normal};
            line-height: 36px;
            margin-bottom: 8px;
        }
    `,
);

export const ConversationText = styled(Typography.TextBody_16_28)`
    margin-bottom: 24px;
    text-align: center;

    @media (max-width: ${breakpoints.md}px) {
        line-height: 24px;
    }
`;

export const ProceedWrapper = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    gap: 0 16px;
`;

export const ProceedButton = styled(Button)`
    margin-top: 24px;
    width: 100%;
    min-width: auto;

    @media (max-width: ${breakpoints.md}px) {
        margin-top: 0;
    }
`;

export const ContentScrollbar = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`;
